<div class="ant-modal-wrap">
    <nz-spin
        nzSimple
        [nzSize]="'large'"></nz-spin>
</div>
